// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

// scrub modulations settings for segmentEndModulation to consume
const makeModulationConfigurations = (mods, engRef) => (
  mods.reduce((a, d, i) => {
    if (d.enabled) {
      a.push({
        engineeringReferenceFlag: +engRef === +d.radioModulationId,
        power: castToFloat(d.power),
        radioModulationId: castToFloat(d.radioModulationId),
        segmentEndRadioModulationId: d.segmentEndRadioModulationId,
      })
    }
    return a
  }, [])
)

export default makeModulationConfigurations
